// Paso de aprobación del registro de minero. Valores = enum del backend
// shared/MineTrace.Shared/Enums/SupplierApprovalStep.cs. Las observaciones del evaluador se
// guardan con este número y el registrador las filtra con el mismo mapa.
//
// Antes cada pantalla tenía su propio mapa y no coincidían: el evaluador guardaba las
// observaciones de "Otros Documentos Legales" con 12 y el registrador buscaba 5 (IGAFOM),
// así que el minero nunca las veía ni podía responderlas, y el paso quedaba bloqueado.
export const SupplierApprovalStep = {
  Identity: 1,
  Accreditation: 2,
  Contract: 3,
  MiningRights: 4,
  Igafom: 5,
  Production: 6,
  Recpo: 7,
  Iqbf: 8,
  Finance: 9,
  Shareholders: 10,
  Verification: 11,
  LegalDocuments: 12,
} as const

/** Tab del wizard/evaluación → paso de aprobación. `consentimiento` no se evalúa (0). */
export const TAB_TO_APPROVAL_STEP = {
  identidad: SupplierApprovalStep.Identity,
  acreditacion: SupplierApprovalStep.Accreditation,
  contrato: SupplierApprovalStep.Contract,
  derechos: SupplierApprovalStep.MiningRights,
  igafom: SupplierApprovalStep.Igafom,
  legaldocs: SupplierApprovalStep.LegalDocuments,
  produccion: SupplierApprovalStep.Production,
  recpo: SupplierApprovalStep.Recpo,
  iqbf: SupplierApprovalStep.Iqbf,
  finanzas: SupplierApprovalStep.Finance,
  accionistas: SupplierApprovalStep.Shareholders,
  verificaciones: SupplierApprovalStep.Verification,
  consentimiento: 0,
} as const

export type ApprovalTab = keyof typeof TAB_TO_APPROVAL_STEP
